import React from 'react';

import LoaderComponent from '@/components/LoaderComponent';
import { BUYER_ACTIVITY_DATA } from '@/features/buyer-activity/utils/helper';
import BuyerActivityCard from '@/features/buyer-activity/components/BuyerActivityCard';

const BuyersActivity = () => {
	const handleBuyerClick = (mixpanelUrl) => {
		window.open(mixpanelUrl, '_blank');
	};

	return (
		<LoaderComponent>
			<div className="top-header assets-top-filter">
				<div className="page-title-area">
					<h1 className="semibold-16 pb-3">Buyer activity</h1>
				</div>
			</div>
			<div className="body-content">
				<div className="buyer-activity-container d-grid gap-4 pt-2">
					{BUYER_ACTIVITY_DATA.map((buyer, index) => (
						<BuyerActivityCard key={index} buyer={buyer} onClick={handleBuyerClick} />
					))}
				</div>
			</div>
		</LoaderComponent>
	);
};

export default BuyersActivity;
